module.exports = __webpack_public_path__ + "img/naked-wines-001-rs.48eafb06.png";